module.exports = __webpack_public_path__ + "media/images/Heart-694cfbe0cdb251c638e7fcf3898f2bf4.png";